<!--
  No phone: reserve the two-line height but show nothing and offer no chat entry.
  In list layout there is no column to align to, so nothing is reserved.
-->
<div class="msgcol" *ngIf="!party?.phone && !listLayout"></div>

<div
  class="msgcol"
  #col
  *ngIf="party?.phone && (!listLayout || displayMessages.length)"
  id="messages-cell-{{index}}"
>
  <ng-container *ngIf="displayMessages.length">
    <!-- top-aligned; a single message sits on the first line, two messages fill both -->
    <div
      class="msgline"
      *ngFor="let msg of displayMessages; let i = index; let last = last"
      [class.msgline--clipped]="i < visibleFrom"
      [ngClass]="{
        'failed': msg.status_sent === 'not_sent' || (msg.status_sent === 'inProcess' && msg.time < (now - 60000)),
        'inbound': !msg.label
      }"
    >
      <!--
        Semantics (match waitlist-notify): inbound = !msg.label (Inbound item, no status);
        label === 'chat' is an OUTBOUND chat and follows status_sent like any preset. Status
        icons key off status_sent, so an inbound item (no status) only shows the blue chat bullet.
      -->
      <span class="msgline-ico">
        <tr-loader *ngIf="msg.status_sent === 'inProcess' && msg.time >= (now - 60000)" [isSpinner]="true"></tr-loader>
        <tr-icon *ngIf="msg.status_sent === 'sent'" [icon]="icon.complete" [color]="color.green" classes="tr-bullet"></tr-icon>
        <tr-icon
          *ngIf="msg.status_sent === 'not_sent' || (msg.status_sent === 'inProcess' && msg.time < (now - 60000))"
          [icon]="icon.exclamation" [color]="color.danger" classes="tr-bullet"
        ></tr-icon>
        <tr-icon *ngIf="!msg.label" [icon]="icon.chat" [color]="color.blue" classes="tr-bullet"></tr-icon>
      </span>
      <!--
        Messages wrap, but a line can still be cut off: its reason/timing ellipsised, an
        unbroken token wider than the column, or the newest message running past the row's
        height. `fit()` measures that per line; the full-text popover arms only then (same
        as Notes), so lines that fit aren't falsely interactive. A click trigger (not hover)
        works on touch/iOS too.
      -->
      <span #txt class="msgline-text"
        [class.msgline-text--clamped]="last && clampLines"
        [style.--msg-clamp]="last ? clampLines : null"
        [attr.role]="truncated[i] ? 'button' : null"
        [ngbPopover]="txt.textContent?.trim() || ''"
        [disablePopover]="!truncated[i]"
        triggers="click"
        container="body" placement="bottom-left bottom-right top-left top-right bottom top">
        <span *ngIf="msg.label && msg.label !== 'chat'">{{ msg.label | notificationLabel | titlecase }}<span *ngIf="msg.type === 'voice'"> {{ msg.type | prettifyNotificationType }}</span></span>
        <span *ngIf="!msg.label || msg.label === 'chat'" [innerHTML]="(msg?.Body || msg?.message)"></span>
        <!--
          Failure reason + timing trail the message inline and are never broken across lines:
          they're supporting detail, so they stay on one line and ellipsis out rather than
          costing the row extra height. For a failed message the reason matters more than the
          timing, so it comes first.
        -->
        <span class="msgline-meta">
          <span class="reason" *ngIf="msg.status_sent === 'not_sent' && msg.data?.failureReason">— {{ msg.data.failureReason }} </span>
          <span class="when" *ngIf="notificationTime === notificationTimeEnum.Absolute">· {{ msg.time | trDateFormat:'M/D h:mm a': timezone }}</span>
          <span class="when" *ngIf="notificationTime === notificationTimeEnum.Relative">· {{ (now - msg.time) | trTimeDelta }} ago</span>
        </span>
      </span>
    </div>
  </ng-container>
</div>
